import { render, staticRenderFns } from "./SupplierInfoDialog.vue?vue&type=template&id=4ac6b5ff&"
import script from "./SupplierInfoDialog.vue?vue&type=script&lang=js&"
export * from "./SupplierInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports